<template>
  <div class="table-container page-container">
    <CollectionsTable :collections="communityCollectionsList" />
  </div>
</template>
<script>
import {
  mapState, mapActions, mapMutations,
} from 'vuex';
import CollectionsTable from '@/components/Collections/CollectionsTable';
export default {
  name: 'Collections',
  components: {
    CollectionsTable,
  },
  computed: {
    ...mapState('Collections', ['communityCollectionsList']),
  },
  async created() {
    this.spinner(true);
    if (!this.communityCollectionsList.length) {
      await this.getListCommunityCollections({
        uploadAll: true,
        spinner: true,
        spinnerOnFirstLoad: true,
      });
    }
    this.spinner(false);
  },
  methods: {
    ...mapActions({
      getListCommunityCollections: 'Collections/getListCommunityCollections',
    }),
    ...mapMutations(['spinner']),
  },
};
</script>
<style lang="scss">
</style>
